var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtcWxg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.06 0 0 8.059 0 18c0 9.94 8.06 18 18 18 9.941 0 18-8.06 18-18 0-9.941-8.06-18-18-18z",
    fill: "#4EAF94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.462 22.354c-2.406 9.643-12.173 15.512-21.818 13.107C4.003 33.057-1.866 23.29.539 13.648 2.943 4.004 12.711-1.866 22.352.538c9.644 2.405 15.513 12.173 13.11 21.816z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.932 15.437c.358-2.396-1.466-3.683-3.96-4.542l.809-3.245-1.975-.492-.788 3.159a80.97 80.97 0 0 0-1.582-.372l.792-3.18-1.973-.493-.81 3.244c-.43-.098-.851-.194-1.261-.296l.002-.01-2.724-.68-.525 2.11s1.465.335 1.434.356c.8.2.944.729.92 1.149l-.92 3.696c.054.014.125.034.204.066l-.04-.01a20.197 20.197 0 0 0-.168-.042l-1.292 5.177c-.098.244-.346.608-.905.47.02.028-1.436-.358-1.436-.358l-.98 2.26 2.57.64c.302.076.6.154.895.23.172.046.343.09.513.134l-.817 3.281 1.973.493.81-3.247c.539.146 1.062.281 1.574.409l-.807 3.231 1.975.492.818-3.275c3.368.637 5.9.38 6.966-2.666.86-2.453-.042-3.867-1.814-4.79 1.29-.297 2.262-1.146 2.522-2.9zm-4.513 6.327c-.56 2.25-4.082 1.32-5.694.894a29.062 29.062 0 0 0-.385-.1l1.084-4.347c.135.033.299.07.485.112 1.666.373 5.084 1.14 4.51 3.441zm-4.174-5.459c1.343.359 4.274 1.141 4.784-.904.522-2.091-2.326-2.722-3.718-3.03-.156-.035-.294-.065-.407-.094l-.983 3.944c.093.023.201.052.324.084z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#000",
    d: "M-4 19.5h43.909V30H-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.717 28.5h-.352v-.682h-.352v-.682h-.352v-.681h-.352v-.682h-.352v-.682h-.352v-.682h-.352v.682h-.352v.682h-.352v.681h-.352v.682h-.352v.682h-.352v.682h-.352V21h1.056v3.75h.352v-.682h.352v-.682h.352v-.681h.352v.681h.352v.682h.352v.682h.352V21h1.056v7.5zM21 28.5h-1.056v-1.023h-.352v-1.023h-.352v-.681h-.352v-.341h-.352v.34h-.352v.683h-.352v1.022h-.352V28.5h-1.056v-1.023h.352v-1.023h.352v-.681h.352v-.682h.352v-.682h-.352v-.682h-.352v-.681h-.352v-1.023h-.352V21h1.056v1.023h.352v1.023h.352v.681h.352v.341h.352v-.34h.352v-.683h.352v-1.022h.352V21H21v1.023h-.352v1.023h-.352v.681h-.352v.682h-.352v.682h.352v.682h.352v.681h.352v1.023H21V28.5zM26.282 27.818h-.352v.341h-.352v.341h-2.464v-.34h-.352v-.342h-.352v-.34h-.352v-.342h-.352v-4.772h.352v-.341h.352v-.341h.352v-.341h.352V21h2.464v.34h.352v.342h.352v.682h-1.056v-.341h-1.76v.34h-.352v.341h-.352v4.091h.352v.341h.352v.341h1.76v-2.045h-.352v.34h-1.056V24.41h2.464v3.41z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcWxg);
export default __webpack_public_path__ + "static/media/BTC-WXG.9c829a0983e21552d6240d335000185e.svg";
export { ForwardRef as ReactComponent };